import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  useNavigate,
} from "react-router-dom";

import "../styles/ProductsPage.css";

const ProductsPage = () => {

  const navigate =
    useNavigate();

  /* ================= STATES ================= */

  const [products, setProducts] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [selectedType,
    setSelectedType] =
    useState("ALL");

  const [visibleProducts,
    setVisibleProducts] =
    useState(6);

  /* ================= FETCH PRODUCTS ================= */

  useEffect(() => {

    const fetchProducts =
      async () => {

        try {

          /* PAGE 1 */

          const res1 =
            await fetch(
              "https://backend.sacmtb.com/api/products?category=Bicycle&page=1"
            );

          const data1 =
            await res1.json();

          /* PAGE 2 */

          const res2 =
            await fetch(
              "https://backend.sacmtb.com/api/products?category=Bicycle&page=2"
            );

          const data2 =
            await res2.json();

            const res3 =
            await fetch(
              "https://backend.sacmtb.com/api/products?category=Bicycle&page=3"
            );

          const data3 =
            await res3.json();

            const res4 =
            await fetch(
              "https://backend.sacmtb.com/api/products?category=Bicycle&page=4"
            );

          const data4 =
            await res4.json();

            const res5 =
            await fetch(
              "https://backend.sacmtb.com/api/products?category=Bicycle&page=5"
            );

          const data5 =
            await res5.json();

          /* COMBINE */

          const allProducts = [

            ...(data1.products || []),
            ...(data2.products || []),
            ...(data3.products || []),
            ...(data4.products || []),
            ...(data5.products || [])
          ];

          /* REMOVE DUPLICATES */

          const uniqueProducts =
            allProducts.filter(
              (
                product,
                index,
                self
              ) =>
                index ===
                self.findIndex(
                  (p) =>
                    p._id ===
                    product._id
                )
            );

          setProducts(
            uniqueProducts
          );

        } catch (error) {

          console.error(
            error
          );

          setProducts([]);

        } finally {

          setLoading(false);
        }
      };

    fetchProducts();

  }, []);

  /* ================= FILTER ================= */

  const filteredProducts =
    selectedType === "ALL"
      ? products
      : products.filter(
          (product) => {

            const type =
              product.type
                ?.toLowerCase()
                .trim();

            return type?.includes(
              selectedType.toLowerCase()
            );
          }
        );

  /* ================= PRODUCTS TO SHOW ================= */

  const displayedProducts =
    filteredProducts.slice(
      0,
      visibleProducts
    );

  /* ================= LOAD MORE ================= */

  const handleLoadMore =
    () => {

      setVisibleProducts(
        filteredProducts.length
      );
    };

  /* ================= LOADING ================= */

  if (loading) {

    return (

      <div className="luxury-loading">

        <h1>
          LOADING <br />
          COLLECTION
        </h1>

      </div>
    );
  }

  /* ================= UI ================= */

  return (

    <div className="luxury-products-page">

      {/* ================= HERO ================= */}

      <section className="luxury-hero">

        <video
          autoPlay
          muted
          loop
          playsInline
          className="luxury-video"
        >

          <source
            src="/videos/mtb.mp4"
            type="video/mp4"
          />

        </video>

        <div className="luxury-overlay">

          <span>
            PREMIUM BICYCLE COLLECTION
          </span>

          <h1>
            RIDE <br />
            WITHOUT <br />
            LIMITS
          </h1>

          <p>
            Discover premium MTB,
            kids and lifestyle
            bicycles crafted for
            adventure, freedom and
            unforgettable rides.
          </p>

        </div>

      </section>

      {/* ================= BIG TEXT ================= */}

      <section className="luxury-statement">

        <h1>
          BUILT FOR <br />
          RIDERS.
        </h1>

      </section>

      {/* ================= FILTERS ================= */}

      <div className="luxury-filter-bar">

        <button
          className={
            selectedType ===
            "ALL"
              ? "active"
              : ""
          }
          onClick={() => {

            setSelectedType(
              "ALL"
            );

            setVisibleProducts(
              6
            );
          }}
        >
          ALL
        </button>

        <button
          className={
            selectedType ===
            "MTB"
              ? "active"
              : ""
          }
          onClick={() => {

            setSelectedType(
              "MTB"
            );

            setVisibleProducts(
              6
            );
          }}
        >
          MTB
        </button>

        <button
          className={
            selectedType ===
            "Kids"
              ? "active"
              : ""
          }
          onClick={() => {

            setSelectedType(
              "Kids"
            );

            setVisibleProducts(
              6
            );
          }}
        >
          KIDS
        </button>

        <button
          className={
            selectedType ===
            "Road"
              ? "active"
              : ""
          }
          onClick={() => {

            setSelectedType(
              "Road"
            );

            setVisibleProducts(
              6
            );
          }}
        >
          ROAD
        </button>

        <button
          className={
            selectedType ===
            "Ladies"
              ? "active"
              : ""
          }
          onClick={() => {

            setSelectedType(
              "Ladies"
            );

            setVisibleProducts(
              6
            );
          }}
        >
          LADIES
        </button>

      </div>

      {/* ================= PRODUCTS ================= */}

      <section className="luxury-editorial-grid">

        {displayedProducts.map(
          (
            product,
            index
          ) => {

            return (

              <div
                key={
                  product._id
                }
                className={`editorial-panel ${
                  index % 4 === 0
                    ? "cyan"
                    : index % 4 ===
                      1
                    ? "pink"
                    : index % 4 ===
                      2
                    ? "cream"
                    : "green"
                }`}
              >

                {/* ================= IMAGE ================= */}

                <Link
                  to={`/productdetailpage/${product._id}`}
                  className="editorial-image"
                >

                  <div className="image-hover-wrapper">

                    {/* MAIN IMAGE */}

                    <img
                      src={
                        product
                          .imageUrls?.[0] ||
                        "/images/default.png"
                      }
                      alt={
                        product.name
                      }
                      className="main-image"
                    />

                    {/* HOVER IMAGE */}

                    {product
                      .imageUrls?.[1] && (

                      <img
                        src={
                          product
                            .imageUrls?.[1]
                        }
                        alt={
                          product.name
                        }
                        className="hover-image"
                      />

                    )}

                  </div>

                </Link>

                {/* ================= CONTENT ================= */}

                <div className="editorial-content">

                  <span>

                    {product.type ||
                      "SAC MTB"}

                  </span>

                  <h2>

                    {product.name
                      .length > 42
                      ? product.name.substring(
                          0,
                          42
                        ) + "..."
                      : product.name}

                  </h2>

                  <p>
                    PREMIUM
                    PERFORMANCE
                    SERIES
                  </p>

                  <div className="editorial-bottom">

                    <h3>

                      ₹
                      {product.discountPrice ||
                        product.price}

                    </h3>

                    <button
                      onClick={() =>
                        navigate(
                          `/productdetailpage/${product._id}`
                        )
                      }
                    >

                      EXPLORE

                    </button>

                  </div>

                </div>

              </div>
            );
          }
        )}

      </section>

      {/* ================= LOAD MORE ================= */}

      {visibleProducts <
        filteredProducts.length && (

        <div className="view-more-wrapper">

          <button
            className="view-more-btn"
            onClick={
              handleLoadMore
            }
          >

            EXPLORE COLLECTION

          </button>

        </div>
      )}

      {/* ================= STORY ================= */}

      <section className="story-section">

        <div className="story-image">

          <img
            src="https://images.unsplash.com/photo-1511994298241-608e28f14fde?q=80&w=2000&auto=format&fit=crop"
            alt="SAC MTB"
          />

        </div>

        <div className="story-content">

          <span>
            THE SAC MTB EXPERIENCE
          </span>

          <h2>
            MORE THAN <br />
            A RIDE
          </h2>

          <p>
            Every bicycle tells a
            story. From childhood
            memories to mountain
            adventures, SAC MTB
            creates experiences
            built on emotion,
            freedom and passion.
          </p>

        </div>

      </section>

      {/* ================= ENDING ================= */}

      <section className="ending-section">

        <h1>
          NOT JUST <br />
          A BICYCLE
        </h1>

      </section>

    </div>
  );
};

export default ProductsPage;